(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$stickyStateProvider', '$urlRouterProvider'];

    function stateConfig($stateProvider, $stickyStateProvider, $urlRouterProvider ) {
        $stateProvider
        .state('required-document', {
            // parent: 'entity',
            parent: 'app',
            url: '/required-document?page&sort&search',
            sticky: true,
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccsTrApp.requiredDocument.home.title'
            },
            views: {
                // 'content@': {
                'required-document@': {
                    templateUrl: 'app/entities/required-document/required-documents.html',
                    controller: 'RequiredDocumentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('requiredDocument');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('required-document-detail', {
            // parent: 'entity',
            parent: 'app',
            url: '/required-document/{id}',
            sticky: true,
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccsTrApp.requiredDocument.detail.title'
            },
            views: {
                // 'content@': {
                'required-document-detail@': {
                    templateUrl: 'app/entities/required-document/required-document-detail.html',
                    controller: 'RequiredDocumentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('requiredDocument');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RequiredDocument', function($stateParams, RequiredDocument) {
                    return RequiredDocument.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'required-document',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('required-document-detail.edit', {
            // parent: 'required-document-detail',
            parent: 'app',
            // url: '/detail/edit',
            url: '/required-document/detail/edit',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/required-document/required-document-dialog.html',
                    controller: 'RequiredDocumentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RequiredDocument', function(RequiredDocument) {
                            return RequiredDocument.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('required-document.new', {
            // parent: 'required-document',
            parent: 'app',
            // url: '/new',
            url: '/required-document/new',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/required-document/required-document-dialog.html',
                    controller: 'RequiredDocumentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                createdOn: null,
                                createdBy: null,
                                modifiedOn: null,
                                modifiedBy: null,
                                path: null,
                                received: null,
                                approved: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('required-document', null, { reload: true });
                }, function() {
                    $state.go('required-document');
                });
            }]
        })
        .state('required-document.edit', {
            // parent: 'required-document',
            parent: 'app',
            // url: '/{id}/edit',
            url: '/required-document/{id}/edit',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/required-document/required-document-dialog.html',
                    controller: 'RequiredDocumentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RequiredDocument', function(RequiredDocument) {
                            return RequiredDocument.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('required-document', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('required-document.delete', {
            // parent: 'required-document',
            parent: 'app',
            // url: '/{id}/delete',
            url: '/required-document/{id}/delete',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/required-document/required-document-delete-dialog.html',
                    controller: 'RequiredDocumentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RequiredDocument', function(RequiredDocument) {
                            return RequiredDocument.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('required-document', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });

        $stickyStateProvider.enableDebug( true );
        
    }

})();
